import {
  CREATE,
  DELETE,
  GET_LIST,
  GET_ONE,
} from 'react-admin'

export function request(apiUrl, type, params) {
  let url = apiUrl + '/admin/researches'
  let options = {}

  switch (type) {
    case CREATE:
      const data = {...params.data}
      options.method = 'POST'
      delete data.parentIds
      options.data = data
      break
    case GET_LIST:
      const {page, perPage} = params.pagination
      const {field, order} = params.sort
      options.params = {
        ...params.filter,
        sort: field,
        order: order,
        start: (page - 1) * perPage,
        perPage: perPage,
      }
      break
    case GET_ONE:
      url += `/${params.id}`
      break
    case DELETE:
      url += `/${params.id}`
      options.method = 'DELETE'
      break
    default:
      break
  }
  return {url, ...options}
}

export function response(res, type, params) {
  let ret = {}
  const {data} = res
  switch (type) {
    case GET_LIST:
      ret = data
      break
    default:
      if (data) ret = {data}
      break
  }
  return ret
}
